import Label from '../../Utils/FormInputs/Label';
import TextField from '../../Utils/FormInputs/TextField';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Divider from '@material-ui/core/Divider';
import PageTitle from '../../Utils/smsTitle';
import { SubHeader } from '../../../Containers/SubHeader';
import { surgeryService } from '../../../services/surgeryService';
import SurgeonPicker from './SurgeonPicker';
import {
  PATHWAY,
  OPERATION_CLASS,
  ANAESTHESIA_TYPE,
  OPERATION_CLASS_LABELS,
  ANAESTHESIA_TYPE_LABELS,
} from '../shared/constants';
import { history } from '../../../Helpers/history';
import { config } from '../../../Helpers/env';
import { CustomSelect } from '../../Utils/FormInputs/SelectInput';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { DataCell, ModuleTable } from '../../Utils/Lists/CollapsibleList';
import { StyledRemoveIcon, StyledCell } from '../../DoctorsModule/doctorStyles';
import CustomDialog from '../../Utils/Dialogs/CustomDialog';
import Form from 'react-bootstrap/Form';

const STEPS = [
  'Patient & Procedure',
  'Date, Theatre & Team',
  'Billing Estimate',
  'Review & Confirm',
];




const formatCurrency = (value) =>
  `USD ${Number(value).toLocaleString()}`;

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 20,
    padding: 20,
  },
  stepper: {
    padding: theme.spacing(3, 0, 4),
  },
  content: {
    minHeight: 360,
    padding: theme.spacing(2, 0),
  },
  navButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
    gap: theme.spacing(1),
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '1rem',
    marginBottom: theme.spacing(2),
    color: '#333',
  },
  readOnlyField: {
    backgroundColor: '#f5f5f5',
  },
  editLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '0.85rem',
    marginLeft: theme.spacing(1),
    textDecoration: 'underline',
  },
  checklistItem: {
    padding: theme.spacing(0.5, 0),
    display: 'flex',
    alignItems: 'center',
  },
  checklistBullet: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  billingRow: {
    padding: theme.spacing(1, 0),
    borderBottom: '1px solid #eee',
  },
  billingTotal: {
    padding: theme.spacing(1.5, 0),
    fontWeight: 700,
  },
  reviewSection: {
    marginBottom: theme.spacing(2),
  },
  reviewCard: {
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    marginBottom: 16,
    overflow: 'hidden',
  },
  reviewCardHeader: {
    padding: '10px 16px',
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #E0E0E0',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  reviewCardHeaderTitle: {
    fontSize: '0.8rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#555',
  },
  reviewCardBody: {
    padding: '12px 16px',
  },
  reviewRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 0',
    borderBottom: '1px solid #F5F5F5',
    '&:last-child': { borderBottom: 'none' },
  },
  reviewLabel: {
    fontWeight: 500,
    color: '#666',
    fontSize: '0.82rem',
  },
  reviewValue: {
    color: '#222',
    fontSize: '0.82rem',
    fontWeight: 600,
    textAlign: 'right',
  },
  reviewTableHead: {
    backgroundColor: '#FAFAFA',
  },
  reviewTableCellHead: {
    fontSize: '0.7rem',
    fontWeight: 700,
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    padding: '8px 12px',
    borderBottom: '2px solid #E0E0E0',
  },
  reviewTableCell: {
    fontSize: '0.82rem',
    padding: '8px 12px',
    color: '#333',
  },
  reviewTotalRow: {
    backgroundColor: '#F5F5F5',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: '0.85rem',
    marginTop: theme.spacing(1),
  },
}));

const INITIAL_FORM_DATA = {
  // Step 0
  patient_name: '',
  patient_number: '',
  visit_id: '',
  diagnosis: '',
  procedure: '',
  pathway: PATHWAY.OUTPATIENT,
  operation_class: OPERATION_CLASS.MINOR,
  // Step 1
  date: '',
  start_time: '',
  duration_hours: 1,
  duration_minutes: 0,
  theatre: '',
  lead_surgeon: '',
  lead_anaesthetist: '',
  scrub_nurse: '',
  circulating_nurse: '',
  anaesthesia_type: ANAESTHESIA_TYPE.GENERAL,
  // Step 2 — billing is mock / read-only
};

const ScheduleSurgeryWizard = ({ match, location }) => {
  const classes = useStyles();
  const referralId = match && match.params ? match.params.referralId : null;

  const queryParams = new URLSearchParams(location && location.search ? location.search : '');
  const preTheatreId = queryParams.get('theatre_id');
  const preDate = queryParams.get('date');
  const preStartTime = queryParams.get('start_time');

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    ...INITIAL_FORM_DATA,
    ...(preDate ? { operation_date: preDate } : {}),
    ...(preStartTime ? { start_time: preStartTime } : {}),
    ...(preTheatreId ? { theatre: Number(preTheatreId) } : {}),
  });
  const [errors, setErrors] = useState({});
  const [referralLocked, setReferralLocked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [completedSteps, setCompletedSteps] = useState({});
  const [availableTheatres, setAvailableTheatres] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [surgeonOptions, setSurgeonOptions] = useState([]);

  // Billing estimate state
  const [billItems, setBillItems] = useState([]);
  const [surgeryServices, setSurgeryServices] = useState([]);

  // Room estimate state (inpatient only)
  const [roomEstimate, setRoomEstimate] = useState({ ward_id: '', room_id: '', estimated_days: 1, daily_rate: 0, total: 0, bill_to: 'cash' });
  const [wards, setWards] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedWard, setSelectedWard] = useState(null);
  const [selectedRoom, setSelectedRoom] = useState(null);

  // Insurance / pre-auth state
  const [insuranceInfo, setInsuranceInfo] = useState(null); // { is_insured, provider_name, scheme_name, co_pay_percentage, insurance_id }
  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [preauthRef, setPreauthRef] = useState('');
  const [preauthJustification, setPreauthJustification] = useState('');
  const [coveredServicesMap, setCoveredServicesMap] = useState({}); // { service_id: { insurance_rate, service_name } }

  // Track whether primary procedure has been seeded into billItems
  const [primarySeeded, setPrimarySeeded] = useState(false);

  // Admission prompt state
  const [admissionPromptOpen, setAdmissionPromptOpen] = useState(false);
  const [scheduledResult, setScheduledResult] = useState(null);

  useEffect(() => {
    surgeryService.searchStaff('').then((res) => {
      const list = Array.isArray(res.data) ? res.data : [];
      setStaffOptions(list.map((s) => ({
        value: s.name,
        label: s.role ? `${s.name} (${s.role})` : s.name,
      })));
    }).catch(() => setStaffOptions([]));

    axios.post(`${config.smsUrl}/doctors/search`, {query: ''}).then((res) => {
      const data = res.data ?? {};
      const list = data.data ?? [];
      setSurgeonOptions(list.map((s) => ({
        value: `${s.first_name ?? ''} ${s.last_name ?? ''}`.trim(),
        label: `${s.first_name ?? ''} ${s.last_name ?? ''}`.trim() + (s.source ? ` (${s.source})` : ''),
      })));
    }).catch(() => setSurgeonOptions([]));
  }, []);

  // Fetch surgery services for billing step
  useEffect(() => {
    const formData = new FormData();
    formData.append('service_type', 'Surgery');
    axios.post(`${config.smsUrl}/cvisit/retrieve_services_by_service_type`, formData)
      .then(res => {
        const data = res.data || [];
        setSurgeryServices(data.map(item => ({
          value: `${item.service_id}-${item.cost}`,
          label: item.service_name
        })));
      }).catch(() => setSurgeryServices([]));
  }, []);

  // Fetch insurance info when visit_id or patient_number is available
  useEffect(() => {
    const visitId = formData.visit_id;
    const patientNumber = formData.patient_number;
    if (!visitId && !patientNumber) {
      setInsuranceInfo(null);
      return;
    }
    const payload = visitId ? { visit_id: visitId } : { patient_number: patientNumber };
    setInsuranceLoading(true);
    axios.post(`${config.smsUrl}/surgery/visit_insurance_info`, payload)
      .then((res) => {
        const data = res.data?.data || res.data || {};
        if (data.is_on_insurance) {
          setInsuranceInfo({
            is_insured: true,
            provider_name: data.provider_name || 'Insurance',
            scheme_name: data.scheme_name || '',
            co_pay_percentage: parseFloat(data.co_pay_percentage || 0),
            insurance_id: data.insurance_id || data.provider_id || null,
          });
          // Store the resolved visit_id for downstream use
          if (data.visit_id && !visitId) {
            setFormData(prev => ({ ...prev, visit_id: data.visit_id }));
          }
        } else {
          setInsuranceInfo({ is_insured: false });
        }
      })
      .catch(() => setInsuranceInfo(null))
      .finally(() => setInsuranceLoading(false));
  }, [formData.visit_id, formData.patient_number]);

  // Fetch covered services when insurance provider is known
  useEffect(() => {
    if (!insuranceInfo || !insuranceInfo.is_insured || !insuranceInfo.insurance_id) {
      setCoveredServicesMap({});
      return;
    }
    axios.post(`${config.smsUrl}/surgery/insurance_covered_services`, {
      provider_id: insuranceInfo.insurance_id,
    })
      .then((res) => {
        const data = res.data?.data || res.data || {};
        setCoveredServicesMap(data.covered_services || {});
      })
      .catch(() => setCoveredServicesMap({}));
  }, [insuranceInfo]);

  // Fetch wards for room estimate
  useEffect(() => {
    axios.get(`${config.smsUrl}/cbedmanager/getAllWards`)
      .then(res => {
        const data = res.data?.wards || res.data || [];
        setWards(data.map(w => ({ value: w.ward_id, label: w.name })));
      }).catch(() => setWards([]));
  }, []);

  // Fetch rooms when ward changes
  useEffect(() => {
    if (!selectedWard) { setRooms([]); return; }
    const formData = new FormData();
    formData.append('ward_id', selectedWard.value);
    axios.post(`${config.smsUrl}/cbedmanager/retrieve_room_by_ward_id`, formData)
      .then(res => {
        const data = res.data?.room || res.data || [];
        setRooms(data.map(r => ({ value: r.room_id, label: r.name, charge: r.charge || 0 })));
      }).catch(() => setRooms([]));
  }, [selectedWard]);

  // Load referral data if referralId is present
  useEffect(() => {
    if (referralId) {
      surgeryService
        .viewReferral(referralId)
        .then((res) => {
          const data = res.data || res;
          const patient = data.patient || {};
          const referral = data.referral || data;
          const service = data.service || {};
          const firstName = patient.first_name || '';
          const lastName = patient.last_name || '';
          const patientName = `${firstName} ${lastName}`.trim();
          const procedure = service.service_name || referral.procedure_requested || referral.procedure || '';
          const diagnosis = referral.referral_reason || referral.diagnosis || '';
          setFormData((prev) => ({
            ...prev,
            patient_name: patientName,
            patient_number: patient.patient_number || referral.patient_number || '',
            visit_id: referral.visit_id || '',
            diagnosis,
            procedure,
          }));
          setReferralLocked(true);
        })
        .catch(() => {
          // referral load failed — allow manual entry
        });
    }
  }, [referralId]);

  const handleChange = (field) => (e) => {
    const value = e && e.target ? e.target.value : e;
    const updates = { [field]: value };
    setFormData((prev) => ({
      ...prev,
      ...updates,
    }));
    if (errors[field]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    }
  };

  // Handler for CustomSelect fields — stores the primitive value and optional extra fields
  const handleSelectChange = (field, extras) => (option) => {
    const updates = { [field]: option ? option.value : '' };
    if (extras) extras(option, updates);
    setFormData((prev) => ({ ...prev, ...updates }));
    if (errors[field]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    }
  };

  const validateStep = (step) => {
    const newErrors = {};
    const sub = true; // Use submitted boolean in future for custom TextField styles
    if (step === 0) {
      if (!formData.patient_number) newErrors.patient_number = 'Patient number is required';
      if (!formData.diagnosis) newErrors.diagnosis = 'Diagnosis is required';
      if (!formData.procedure) newErrors.procedure = 'Procedure is required';
      if (!formData.pathway) newErrors.pathway = 'Pathway is required';
    }
    if (step === 1) {
      if (!formData.date) newErrors.date = 'Date is required';
      if (!formData.start_time) newErrors.start_time = 'Start time is required';
      if (!formData.theatre) newErrors.theatre = 'Theatre selection is required';
      if (!formData.lead_surgeon) newErrors.lead_surgeon = 'Lead surgeon is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setCompletedSteps((prev) => ({ ...prev, [activeStep]: true }));
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleStepClick = (stepIndex) => {
    if (completedSteps[stepIndex] || stepIndex < activeStep) {
      setActiveStep(stepIndex);
    }
  };

  const handleSubmit = () => {
    setSubmitting(true);
    const durationMins = Number(formData.duration_hours) * 60 + Number(formData.duration_minutes);
    let theatreBooking = null;
    if (formData.theatre && formData.start_time && (formData.operation_date || formData.date)) {
      const [sh, sm] = formData.start_time.split(':').map(Number);
      const endMins = sh * 60 + sm + durationMins;
      const endH = Math.floor(endMins / 60);
      const endM = endMins % 60;
      const end_time = `${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`;
      theatreBooking = {
        theatre_id: formData.theatre,
        booking_date: formData.operation_date || formData.date,
        start_time: formData.start_time,
        end_time,
        booked_by: 1,
        status: 0,
      };
    }
    // Build pre-auth data only if there are items billed to insurance
    const hasInsuranceItems = billItems.some(i => i.bill_to === 'insurance' && i.service_id);
    let preauthData = null;
    if (insuranceInfo && insuranceInfo.is_insured && hasInsuranceItems) {
      preauthData = {
        insurance_id: insuranceInfo.insurance_id || 0,
        reference_number: preauthRef || null,
        estimated_amount: insuranceItemsTotal,
        clinical_justification: preauthJustification || null,
      };
    }

    // Tag each bill item with bill_to so backend knows how to categorize
    const taggedBillItems = billItems.map(item => ({
      ...item,
      bill_to: item.bill_to || 'cash',
    }));

    const payload = {
      ...formData,
      referral_id: referralId || null,
      duration_minutes_total: durationMins,
      theatre_booking: theatreBooking,
      additional_bill_items: taggedBillItems,
      ...(formData.pathway === PATHWAY.INPATIENT && roomEstimate.room_id ? { room_estimate: roomEstimate } : {}),
      ...(preauthData ? { preauth_data: preauthData } : {}),
    };
    surgeryService
      .createSurgery(payload)
      .then((res) => {
        const data = res.data || res;
        const result = {
          surgery_id: data.surgery_id || data.id || '',
          visit_id: data.visit_id || '',
          patient_number: formData.patient_number,
          pathway: formData.pathway,
        };
        setScheduledResult(result);
        // Only prompt admission for inpatient (not daycase/outpatient)
        if (formData.pathway !== PATHWAY.OUTPATIENT) {
          setAdmissionPromptOpen(true);
        } else {
          history.push('/surgery/list');
        }
        setSubmitting(false);
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  const handleUnlockReferral = () => {
    setReferralLocked(false);
  };

  useEffect(() => {
    if (activeStep === 1 || activeStep === 0) {
      surgeryService
        .listTheatres()
        .then((theatreRes) => {
          const theatreList = theatreRes.data?.theatres || theatreRes.data || [];
          const options = theatreList.map((t) => ({
            value: t.theatre_id,
            label: t.name,
          }));
          setAvailableTheatres(options);
        })
        .catch(() => {
          setAvailableTheatres([]);
        });
    }
  }, [activeStep]);

  const operationClassOptions = Object.entries(OPERATION_CLASS_LABELS).map(([key, label]) => ({
    value: key,
    label,
  }));

  const anaesthesiaTypeOptions = Object.entries(ANAESTHESIA_TYPE_LABELS).map(([key, label]) => ({
    value: key,
    label,
  }));

  // ─── Step renderers ─────────────────────────────────────────────────────────

  const renderPatientProcedure = () => (
    <div>
      <Typography className={classes.sectionTitle}>Patient & Procedure Details</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Patient Name" />
            <TextField
              name="patient_name"
              value={formData.patient_name}
              onChange={handleChange('patient_name')}
              disabled={referralLocked}
            />
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Patient Number" type />
            <TextField
              name="patient_number"
              value={formData.patient_number}
              onChange={handleChange('patient_number')}
              disabled={referralLocked}
            />
            {errors.patient_number && (
              <small className="text-danger d-block mt-1">{errors.patient_number}</small>
            )}
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Diagnosis" type />
            <TextField
              name="diagnosis"
              value={formData.diagnosis}
              onChange={handleChange('diagnosis')}
              disabled={referralLocked}
            />
            {errors.diagnosis && (
              <small className="text-danger d-block mt-1">{errors.diagnosis}</small>
            )}
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Procedure" type />
            <TextField
              name="procedure"
              value={formData.procedure}
              onChange={handleChange('procedure')}
              disabled={referralLocked}
            />
            {errors.procedure && (
              <small className="text-danger d-block mt-1">{errors.procedure}</small>
            )}
          </Form.Group>
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Pathway" />
            <div style={{ display: 'flex', gap: '20px', marginTop: '8px' }}>
              <Form.Check
                type="radio"
                id="pathway-outpatient"
                name="pathway"
                value={PATHWAY.OUTPATIENT}
                label="Outpatient (Day-Case)"
                checked={formData.pathway === PATHWAY.OUTPATIENT}
                onChange={handleChange('pathway')}
              />
              <Form.Check
                type="radio"
                id="pathway-inpatient"
                name="pathway"
                value={PATHWAY.INPATIENT}
                label="Inpatient"
                checked={formData.pathway === PATHWAY.INPATIENT}
                onChange={handleChange('pathway')}
              />
            </div>
            {errors.pathway && (
              <small className="text-danger d-block mt-1">{errors.pathway}</small>
            )}
          </Form.Group>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Operation Class" />
            <CustomSelect
              value={operationClassOptions.find(o => o.value === formData.operation_class) || null}
              onChange={handleSelectChange('operation_class')}
              options={operationClassOptions}
              placeholder="Select class..."
            />
          </Form.Group>
        </Grid>
      </Grid>
    </div>
  );

  const renderDateTheatreTeam = () => (
    <div>
      <Typography className={classes.sectionTitle}>Date, Theatre & Team</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Form.Group>
            <Label name="Date" type />
            <TextField
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange('date')}
            />
            {errors.date && (
              <small className="text-danger d-block mt-1">{errors.date}</small>
            )}
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Form.Group>
            <Label name="Start Time" type />
            <TextField
              type="time"
              name="start_time"
              value={formData.start_time}
              onChange={handleChange('start_time')}
            />
            {errors.start_time && (
              <small className="text-danger d-block mt-1">{errors.start_time}</small>
            )}
          </Form.Group>
        </Grid>
        <Grid item xs={6} sm={2}>
          <Form.Group>
            <Label name="Hours" />
            <TextField
              type="number"
              name="duration_hours"
              min="0"
              max="12"
              value={formData.duration_hours}
              onChange={handleChange('duration_hours')}
            />
          </Form.Group>
        </Grid>
        <Grid item xs={6} sm={2}>
          <Form.Group>
            <Label name="Minutes" />
            <TextField
              type="number"
              name="duration_minutes"
              min="0"
              max="59"
              value={formData.duration_minutes}
              onChange={handleChange('duration_minutes')}
            />
          </Form.Group>
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Theatre" type />
            <CustomSelect
              value={availableTheatres.find(o => String(o.value) === String(formData.theatre)) || null}
              onChange={handleSelectChange('theatre', (opt, updates) => {
                updates.theatre_name = opt ? opt.label : '';
              })}
              options={availableTheatres}
              placeholder="Select theatre..."
            />
            {errors.theatre && (
              <small className="text-danger d-block mt-1">{errors.theatre}</small>
            )}
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Lead Surgeon" type />
            <CustomSelect
              value={surgeonOptions.find(o => o.value === formData.lead_surgeon) || null}
              onChange={handleSelectChange('lead_surgeon')}
              options={surgeonOptions}
              placeholder="Select surgeon..."
            />
            {errors.lead_surgeon && (
              <small className="text-danger d-block mt-1">{errors.lead_surgeon}</small>
            )}
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Lead Anaesthetist" />
            <CustomSelect
              value={staffOptions.find(o => o.value === formData.lead_anaesthetist) || null}
              onChange={handleSelectChange('lead_anaesthetist')}
              options={staffOptions}
              placeholder="Select anaesthetist..."
            />
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Scrub Nurse" />
            <CustomSelect
              value={staffOptions.find(o => o.value === formData.scrub_nurse) || null}
              onChange={handleSelectChange('scrub_nurse')}
              options={staffOptions}
              placeholder="Select scrub nurse..."
            />
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Circulating Nurse" />
            <CustomSelect
              value={staffOptions.find(o => o.value === formData.circulating_nurse) || null}
              onChange={handleSelectChange('circulating_nurse')}
              options={staffOptions}
              placeholder="Select circulating nurse..."
            />
          </Form.Group>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Form.Group>
            <Label name="Anaesthesia Type" />
            <CustomSelect
              value={anaesthesiaTypeOptions.find(o => o.value === formData.anaesthesia_type) || null}
              onChange={handleSelectChange('anaesthesia_type')}
              options={anaesthesiaTypeOptions}
              placeholder="Select type..."
            />
          </Form.Group>
        </Grid>
      </Grid>
    </div>
  );


  // Auto-seed the primary procedure as the first (locked) billing item
  useEffect(() => {
    if (primarySeeded || !formData.procedure || surgeryServices.length === 0) return;
    const procedureName = formData.procedure.toLowerCase().trim();
    const match = surgeryServices.find(
      (s) => s.label && s.label.toLowerCase().trim() === procedureName
    );
    if (match) {
      const parts = match.value.split('-');
      const serviceId = parseInt(parts[0]);
      let rate = parseInt(parts[1]) || 0;

      // Use insurance rate if covered
      const isInsured = insuranceInfo && insuranceInfo.is_insured;
      const covered = isInsured && coveredServicesMap[serviceId];
      if (covered && covered.insurance_rate > 0) {
        rate = covered.insurance_rate;
      }

      setBillItems((prev) => {
        // Don't double-add if already there
        if (prev.length > 0 && prev[0].service_id === serviceId && prev[0].isPrimary) return prev;
        return [
          {
            service_id: serviceId,
            service_name: match.label,
            service: match,
            rate,
            quantity: 1,
            item_type: 'Surgery',
            isPrimary: true,
            covered: isInsured ? !!covered : null,
            bill_to: isInsured && covered ? 'insurance' : 'cash',
          },
          ...prev.filter((item) => !item.isPrimary),
        ];
      });
      setPrimarySeeded(true);
    }
  }, [formData.procedure, surgeryServices, primarySeeded, insuranceInfo, coveredServicesMap]);

  const handleAddBillRow = () => {
    setBillItems(prev => [...prev, {
      service_id: '',
      service_name: '',
      service: null,
      rate: 0,
      quantity: 1,
      item_type: 'Surgery',
      isPrimary: false,
      covered: null,
      bill_to: 'cash',
    }]);
  };

  const handleSelectBillService = (val, index) => {
    if (!val) return;
    const parts = val.value.split('-');
    const serviceId = parseInt(parts[0]);
    let defaultRate = parseInt(parts[1]) || 0;

    // Use insurance rate if covered
    const isInsured = insuranceInfo && insuranceInfo.is_insured;
    const covered = isInsured && coveredServicesMap[serviceId];
    if (covered && covered.insurance_rate > 0) {
      defaultRate = covered.insurance_rate;
    }

    setBillItems(prev => prev.map((item, i) =>
      i === index ? {
        ...item,
        service_id: serviceId,
        service_name: val.label,
        service: val,
        rate: defaultRate,
        covered: isInsured ? !!covered : null,
        bill_to: isInsured && covered ? 'insurance' : 'cash',
      } : item
    ));
  };

  const handleRemoveBillItem = (index) => {
    // Never remove the primary procedure
    if (billItems[index] && billItems[index].isPrimary) return;
    setBillItems(billItems.filter((_, i) => i !== index));
  };

  // Filter dropdown: exclude the primary procedure's service_id
  const primaryServiceId = billItems.length > 0 && billItems[0].isPrimary ? billItems[0].service_id : null;
  const filteredSurgeryServices = primaryServiceId
    ? surgeryServices.filter((s) => {
        const sId = parseInt(s.value.split('-')[0]);
        return sId !== primaryServiceId;
      })
    : surgeryServices;

  const handleWardChange = (val) => {
    setSelectedWard(val);
    setSelectedRoom(null);
    setRoomEstimate(prev => ({ ...prev, ward_id: val ? val.value : '', room_id: '', daily_rate: 0, total: 0 }));
  };

  const handleRoomChange = (val) => {
    setSelectedRoom(val);
    const rate = val ? (val.charge || 0) : 0;
    setRoomEstimate(prev => ({
      ...prev,
      room_id: val ? val.value : '',
      daily_rate: rate,
      total: rate * prev.estimated_days
    }));
  };

  const handleDaysChange = (e) => {
    const raw = e.target.value;
    const days = parseInt(raw, 10);
    const validDays = isNaN(days) ? 0 : days;
    setRoomEstimate(prev => ({ ...prev, estimated_days: raw, total: prev.daily_rate * validDays }));
  };

  const isInsuredPatient = insuranceInfo && insuranceInfo.is_insured;
  const billingSubtotal = billItems.reduce((sum, item) => sum + ((parseFloat(item.rate) || 0) * (parseInt(item.quantity) || 0)), 0);
  const billingGrandTotal = billingSubtotal + (formData.pathway === PATHWAY.INPATIENT ? roomEstimate.total : 0);

  // Per-item insurance/cash split
  const insuranceBillItems = billItems.filter(i => i.bill_to === 'insurance' && i.service_id);
  const cashBillItems = billItems.filter(i => i.bill_to !== 'insurance' && i.service_id);
  const insuranceItemsTotal = insuranceBillItems.reduce((s, i) => s + ((parseFloat(i.rate) || 0) * (parseInt(i.quantity) || 0)), 0);
  const cashItemsTotal = cashBillItems.reduce((s, i) => s + ((parseFloat(i.rate) || 0) * (parseInt(i.quantity) || 0)), 0);
  const roomTotal = formData.pathway === PATHWAY.INPATIENT ? roomEstimate.total : 0;
  const roomToInsurance = roomEstimate.bill_to === 'insurance' ? roomTotal : 0;
  const roomToCash = roomEstimate.bill_to === 'insurance' ? 0 : roomTotal;
  const totalInsuranceAmount = insuranceItemsTotal + roomToInsurance;
  const coPayPct = isInsuredPatient ? (insuranceInfo.co_pay_percentage || 0) : 0;
  const coPayAmount = coPayPct > 0 ? Math.round(totalInsuranceAmount * coPayPct / 100) : 0;
  const insurerPays = totalInsuranceAmount - coPayAmount;
  const patientResponsibility = cashItemsTotal + coPayAmount + roomToCash;

  // Determine insurance scenario
  const allItemsHaveService = billItems.length > 0 && billItems.every(i => i.service_id);
  const insuranceScenario = !isInsuredPatient ? 'cash'
    : insuranceBillItems.length === billItems.filter(i => i.service_id).length ? 'full'
    : insuranceBillItems.length === 0 ? 'none'
    : 'partial';

  const handleToggleBillTo = (idx) => {
    setBillItems(prev => prev.map((item, i) =>
      i === idx ? { ...item, bill_to: item.bill_to === 'insurance' ? 'cash' : 'insurance' } : item
    ));
  };

  const billHeadData = [
    { item: 'Service', toolTip: 'Select a surgery service', isRequired: true },
    { item: 'Rate (USD)' },
    { item: 'Qty' },
    { item: 'Subtotal' },
    ...(isInsuredPatient ? [{ item: 'Bill To' }] : []),
    { item: 'Action' },
  ];

  const renderBillingEstimate = () => {
    const BillToToggle = ({ value, onChange, disabled }) => (
      <div style={{ display: 'inline-flex', borderRadius: 6, overflow: 'hidden', border: '1px solid #E0E0E0' }}>
        <button
          type="button"
          onClick={() => !disabled && onChange('insurance')}
          style={{
            padding: '3px 10px', fontSize: '0.7rem', fontWeight: 600, border: 'none', cursor: disabled ? 'default' : 'pointer',
            backgroundColor: value === 'insurance' ? '#1565C0' : '#fff',
            color: value === 'insurance' ? '#fff' : '#666',
          }}
        >
          Insurance
        </button>
        <button
          type="button"
          onClick={() => !disabled && onChange('cash')}
          style={{
            padding: '3px 10px', fontSize: '0.7rem', fontWeight: 600, border: 'none', borderLeft: '1px solid #E0E0E0',
            cursor: disabled ? 'default' : 'pointer',
            backgroundColor: value === 'cash' ? '#757575' : '#fff',
            color: value === 'cash' ? '#fff' : '#666',
          }}
        >
          Cash
        </button>
      </div>
    );

    return (
      <div>
        <Typography className={classes.sectionTitle}>Billing Estimate</Typography>

        {/* ─── Insurance banner (shown at top for insured patients) ─── */}
        {insuranceLoading && (
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>Loading insurance info...</Typography>
        )}

        {isInsuredPatient && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
            backgroundColor: '#E3F2FD', borderRadius: 8, marginBottom: 16, border: '1px solid #90CAF9',
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%', backgroundColor: '#1565C0',
              color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 14, flexShrink: 0,
            }}>
              {(insuranceInfo.provider_name || 'I')[0]}
            </div>
            <div style={{ flex: 1 }}>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {insuranceInfo.provider_name}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {insuranceInfo.scheme_name || 'Insurance'}
                {coPayPct > 0 && ` · ${coPayPct}% co-pay`}
                {coPayPct === 0 && ' · Full coverage'}
              </Typography>
            </div>
            {isInsuredPatient && (
              <Typography variant="caption" style={{
                padding: '4px 10px', borderRadius: 12, fontWeight: 600, fontSize: '0.7rem',
                backgroundColor: insuranceScenario === 'full' ? '#E8F5E9' : insuranceScenario === 'partial' ? '#FFF3E0' : '#FFEBEE',
                color: insuranceScenario === 'full' ? '#2E7D32' : insuranceScenario === 'partial' ? '#E65100' : '#C62828',
              }}>
                {insuranceScenario === 'full' ? 'All items on insurance' : insuranceScenario === 'partial' ? 'Partial coverage' : 'No items on insurance'}
              </Typography>
            )}
          </div>
        )}

        {insuranceInfo && !insuranceInfo.is_insured && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
            backgroundColor: '#F5F5F5', borderRadius: 8, marginBottom: 16, border: '1px solid #E0E0E0',
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%', backgroundColor: '#757575',
              color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 14, flexShrink: 0,
            }}>$</div>
            <div>
              <Typography variant="body2" style={{ fontWeight: 600 }}>Cash / Self-Pay</Typography>
              <Typography variant="caption" color="textSecondary">
                Patient responsible for full amount — payment via billing list.
              </Typography>
            </div>
          </div>
        )}

        {/* ─── Billing items table ─── */}
        {isInsuredPatient && (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 8 }}>
            Use the "Bill To" column to assign each item to insurance or cash. Covered items default to insurance.
          </Typography>
        )}

        <ModuleTable headData={billHeadData}>
          {billItems.map((item, idx) => {
            const isCovered = isInsuredPatient && item.covered === true;
            const isNotCovered = isInsuredPatient && item.service_id && item.covered === false;
            const billToInsurance = item.bill_to === 'insurance';

            // Row background: light blue for insurance, light amber for uncovered-on-insurance, default for cash
            let rowBg = {};
            if (isInsuredPatient && item.service_id) {
              if (billToInsurance) {
                rowBg = { backgroundColor: '#F0F7FF' };
              } else if (isNotCovered) {
                rowBg = { backgroundColor: '#FFF8E1' };
              }
            }

            return (
              <TableRow key={idx} style={rowBg}>
                <DataCell variant="200">
                  {item.isPrimary ? (
                    <span>
                      {item.service_name}
                      <span style={{ fontSize: '0.7rem', color: '#1976D2', marginLeft: 6, fontWeight: 600 }}>
                        (Primary)
                      </span>
                    </span>
                  ) : item.service_id ? (
                    <span>
                      {item.service_name}
                      {isInsuredPatient && item.service_id && (
                        <span style={{
                          fontSize: '0.6rem', fontWeight: 600, marginLeft: 6,
                          color: isCovered ? '#2E7D32' : '#E65100',
                        }}>
                          {isCovered ? '(Covered)' : '(Not on panel)'}
                        </span>
                      )}
                    </span>
                  ) : (
                    <CustomSelect
                      value={item.service}
                      onChange={(val) => handleSelectBillService(val, idx)}
                      options={filteredSurgeryServices}
                      placeholder="Select service..."
                    />
                  )}
                </DataCell>
                <DataCell variant="150">
                  <TextField
                    type="number"
                    value={item.rate}
                    style={item.isPrimary ? { pointerEvents: 'none' } : {}}
                    onChange={item.isPrimary ? undefined : (e) => {
                      const v = e && e.target ? e.target.value : '';
                      setBillItems(prev => prev.map((it, i) => i === idx ? { ...it, rate: v === '' ? '' : parseFloat(v) } : it));
                    }}
                    onBlur={item.isPrimary ? undefined : () => {
                      setBillItems(prev => prev.map((it, i) => i === idx ? { ...it, rate: parseFloat(it.rate) || 0 } : it));
                    }}
                  />
                </DataCell>
                <DataCell>
                  <TextField
                    type="number"
                    value={item.quantity}
                    style={item.isPrimary ? { pointerEvents: 'none', width: 60 } : { width: 60 }}
                    onChange={item.isPrimary ? undefined : (e) => {
                      const v = e && e.target ? e.target.value : '';
                      setBillItems(prev => prev.map((it, i) => i === idx ? { ...it, quantity: v === '' ? '' : parseInt(v) } : it));
                    }}
                    onBlur={item.isPrimary ? undefined : () => {
                      setBillItems(prev => prev.map((it, i) => i === idx ? { ...it, quantity: parseInt(it.quantity) || 1 } : it));
                    }}
                  />
                </DataCell>
                <DataCell>
                  {((parseFloat(item.rate) || 0) * (parseInt(item.quantity) || 0)).toLocaleString()}
                </DataCell>
                {isInsuredPatient && (
                  <DataCell>
                    {!item.service_id ? (
                      <span style={{ color: '#999', fontSize: '0.75rem' }}>--</span>
                    ) : (
                      <BillToToggle
                        value={item.bill_to || 'cash'}
                        onChange={(val) => handleToggleBillTo(idx)}
                      />
                    )}
                  </DataCell>
                )}
                <DataCell>
                  {item.isPrimary ? (
                    <span style={{ color: '#bbb', fontSize: '0.75rem' }}>Locked</span>
                  ) : (
                    <Tooltip title="Remove">
                      <IconButton type="button" onClick={() => handleRemoveBillItem(idx)}>
                        <StyledRemoveIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </DataCell>
              </TableRow>
            );
          })}
          <TableRow>
            <StyledCell colSpan={billHeadData.length}>
              <button type="button" onClick={handleAddBillRow} className="btn btn-sm sms-gray-btn" id="add-row">
                Add another line
              </button>
            </StyledCell>
          </TableRow>
        </ModuleTable>

        {/* ─── Room Estimate — inpatient only ─── */}
        {formData.pathway === PATHWAY.INPATIENT && (
          <div style={{ marginTop: 20 }}>
            <Typography className={classes.sectionTitle}>Room / Ward Estimate</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <Form.Group>
                  <Label name="Ward" />
                  <CustomSelect value={selectedWard} onChange={handleWardChange} options={wards} placeholder="Select ward..." />
                </Form.Group>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Form.Group>
                  <Label name="Room" />
                  <CustomSelect value={selectedRoom} onChange={handleRoomChange} options={rooms} placeholder="Select room..." />
                </Form.Group>
              </Grid>
              <Grid item xs={6} sm={1}>
                <Form.Group>
                  <Label name="Days" />
                  <TextField type="number" name="estimated_days" min="1" value={roomEstimate.estimated_days} onChange={handleDaysChange} />
                </Form.Group>
              </Grid>
              <Grid item xs={6} sm={1}>
                <Form.Group>
                  <Label name="Daily Rate" />
                  <TextField value={roomEstimate.daily_rate.toLocaleString()} disabled style={{ backgroundColor: '#e9ecef' }} />
                </Form.Group>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Form.Group>
                  <Label name="Room Total" />
                  <TextField value={`USD ${roomEstimate.total.toLocaleString()}`} disabled style={{ backgroundColor: '#e9ecef', fontWeight: 'bold' }} />
                </Form.Group>
              </Grid>
              {isInsuredPatient && (
                <Grid item xs={12} sm={2}>
                  <Form.Group>
                    <Label name="Bill To" />
                    <div style={{ marginTop: 4 }}>
                      <BillToToggle
                        value={roomEstimate.bill_to || 'cash'}
                        onChange={(val) => setRoomEstimate(prev => ({ ...prev, bill_to: val }))}
                      />
                    </div>
                  </Form.Group>
                </Grid>
              )}
            </Grid>
          </div>
        )}

        {/* ─── Billing summary ─── */}
        <Divider style={{ margin: '20px 0 16px' }} />

        {isInsuredPatient ? (
          <Grid container spacing={2}>
            {/* Insurance bill summary */}
            <Grid item xs={12} sm={6}>
              <div style={{ padding: '12px 16px', backgroundColor: '#E3F2FD', borderRadius: 8, border: '1px solid #90CAF9' }}>
                <Typography variant="caption" style={{ fontWeight: 700, color: '#1565C0', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.65rem' }}>
                  Insurance Bill ({insuranceInfo.provider_name})
                </Typography>
                <Typography variant="h6" style={{ fontWeight: 700, color: '#1565C0', marginTop: 4 }}>
                  {formatCurrency(totalInsuranceAmount)}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {insuranceBillItems.length} item{insuranceBillItems.length !== 1 ? 's' : ''} billed to insurance
                </Typography>
                {roomToInsurance > 0 && (
                  <div style={{ marginTop: 4 }}>
                    <Typography variant="caption" color="textSecondary">
                      + Room/Ward: {formatCurrency(roomToInsurance)}
                    </Typography>
                  </div>
                )}
                {coPayPct > 0 && totalInsuranceAmount > 0 && (
                  <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid #90CAF9' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="caption" color="textSecondary">Insurer pays ({100 - coPayPct}%)</Typography>
                      <Typography variant="caption" style={{ fontWeight: 600, color: '#2E7D32' }}>{formatCurrency(insurerPays)}</Typography>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="caption" color="textSecondary">Patient co-pay ({coPayPct}%)</Typography>
                      <Typography variant="caption" style={{ fontWeight: 600 }}>{formatCurrency(coPayAmount)}</Typography>
                    </div>
                  </div>
                )}
              </div>
            </Grid>
            {/* Cash bill summary */}
            <Grid item xs={12} sm={6}>
              <div style={{ padding: '12px 16px', backgroundColor: cashItemsTotal > 0 ? '#FFF8E1' : '#F5F5F5', borderRadius: 8, border: `1px solid ${cashItemsTotal > 0 ? '#FFE082' : '#E0E0E0'}` }}>
                <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.65rem' }}>
                  Patient Cash Bill
                </Typography>
                <Typography variant="h6" style={{ fontWeight: 700, color: cashItemsTotal > 0 ? '#E65100' : '#999', marginTop: 4 }}>
                  {formatCurrency(cashItemsTotal)}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {cashBillItems.length} item{cashBillItems.length !== 1 ? 's' : ''} billed as cash
                </Typography>
                {roomToCash > 0 && (
                  <div style={{ marginTop: 4 }}>
                    <Typography variant="caption" color="textSecondary">
                      + Room/Ward: {formatCurrency(roomToCash)}
                    </Typography>
                  </div>
                )}
              </div>
            </Grid>
            {/* Patient total responsibility */}
            <Grid item xs={12}>
              <div style={{ padding: '12px 16px', backgroundColor: '#F5F5F5', borderRadius: 8, border: '1px solid #E0E0E0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <Typography variant="body2" style={{ fontWeight: 700 }}>Total Patient Responsibility</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {cashItemsTotal > 0 ? `Cash items (${formatCurrency(cashItemsTotal)})` : ''}
                    {cashItemsTotal > 0 && coPayAmount > 0 ? ' + ' : ''}
                    {coPayAmount > 0 ? `Co-pay (${formatCurrency(coPayAmount)})` : ''}
                    {formData.pathway === PATHWAY.INPATIENT && roomEstimate.total > 0 ? ` + Room (${formatCurrency(roomEstimate.total)})` : ''}
                    {patientResponsibility === 0 ? 'Fully covered by insurance' : ''}
                  </Typography>
                </div>
                <Typography variant="h6" style={{ fontWeight: 700 }}>
                  {formatCurrency(patientResponsibility)}
                </Typography>
              </div>
            </Grid>
          </Grid>
        ) : (
          <div style={{ padding: '12px 16px', backgroundColor: '#e8f5e9', borderRadius: 6, fontWeight: 700, fontSize: '1.1rem' }}>
            Estimated Total: {formatCurrency(billingGrandTotal)}
          </div>
        )}

        {/* ─── Pre-auth fields (insurance patients with items on insurance) ─── */}
        {isInsuredPatient && insuranceBillItems.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <Typography className={classes.sectionTitle}>Pre-Authorisation</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Form.Group>
                  <Label name="Pre-Auth Reference Number" />
                  <TextField
                    name="preauth_ref"
                    value={preauthRef}
                    onChange={(e) => setPreauthRef(e.target.value)}
                    placeholder="e.g. PA-2026-00123"
                  />
                </Form.Group>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Form.Group>
                  <Label name="Clinical Justification (optional)" />
                  <TextField
                    name="preauth_justification"
                    value={preauthJustification}
                    onChange={(e) => setPreauthJustification(e.target.value)}
                    placeholder="Reason for surgery..."
                  />
                </Form.Group>
              </Grid>
            </Grid>
            <Typography variant="caption" color="textSecondary" style={{ marginTop: 4, display: 'block' }}>
              A pre-authorisation request will be submitted to {insuranceInfo.provider_name} for the insurance-billed items.
            </Typography>
          </div>
        )}
      </div>
    );
  };

  const ReviewRow = ({ label, value }) => (
    <div className={classes.reviewRow}>
      <span className={classes.reviewLabel}>{label}</span>
      <span className={classes.reviewValue}>{value || '—'}</span>
    </div>
  );

  const ReviewCard = ({ icon, title, children }) => (
    <div className={classes.reviewCard}>
      <div className={classes.reviewCardHeader}>
        {icon && <span style={{ fontSize: '0.85rem' }}>{icon}</span>}
        <span className={classes.reviewCardHeaderTitle}>{title}</span>
      </div>
      <div className={classes.reviewCardBody}>{children}</div>
    </div>
  );

  const renderReviewConfirm = () => {
    const isInsured = isInsuredPatient;
    const hasInsItems = insuranceBillItems.length > 0;

    const ReviewItemTable = ({ items, label, bgColor }) => (
      <div className={classes.reviewCard} style={{ marginBottom: 12 }}>
        <div className={classes.reviewCardHeader} style={{ backgroundColor: bgColor || '#FAFAFA' }}>
          <span className={classes.reviewCardHeaderTitle}>{label}</span>
        </div>
        {items.length > 0 ? (
          <Table size="small">
            <TableHead className={classes.reviewTableHead}>
              <TableRow>
                <TableCell className={classes.reviewTableCellHead}>Item</TableCell>
                <TableCell className={classes.reviewTableCellHead} align="right">Rate</TableCell>
                <TableCell className={classes.reviewTableCellHead} align="center">Qty</TableCell>
                <TableCell className={classes.reviewTableCellHead} align="right">Subtotal</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell className={classes.reviewTableCell}>
                    {item.service_name || '--'}
                    {item.isPrimary && (
                      <Chip label="Primary" size="small" style={{ marginLeft: 6, height: 18, fontSize: '0.6rem', fontWeight: 600, backgroundColor: '#E3F2FD', color: '#1565C0' }} />
                    )}
                  </TableCell>
                  <TableCell className={classes.reviewTableCell} align="right">{Number(parseFloat(item.rate) || 0).toLocaleString()}</TableCell>
                  <TableCell className={classes.reviewTableCell} align="center">{parseInt(item.quantity) || 1}</TableCell>
                  <TableCell className={classes.reviewTableCell} align="right" style={{ fontWeight: 600 }}>
                    {((parseFloat(item.rate) || 0) * (parseInt(item.quantity) || 1)).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className={classes.reviewCardBody}>
            <Typography variant="caption" color="textSecondary">No items</Typography>
          </div>
        )}
      </div>
    );

    return (
      <div>
        <Typography className={classes.sectionTitle} style={{ marginBottom: 16 }}>
          Review & Confirm
        </Typography>

        <Grid container spacing={2}>
          {/* Left column — Patient, Schedule */}
          <Grid item xs={12} md={6}>
            <ReviewCard title="Patient & Procedure">
              <ReviewRow label="Patient" value={formData.patient_name} />
              <ReviewRow label="MRN" value={formData.patient_number} />
              <ReviewRow label="Diagnosis" value={formData.diagnosis} />
              <ReviewRow label="Procedure" value={formData.procedure} />
              <ReviewRow
                label="Pathway"
                value={formData.pathway === PATHWAY.OUTPATIENT ? 'Day-Case (Outpatient)' : 'Inpatient'}
              />
              <ReviewRow
                label="Class"
                value={OPERATION_CLASS_LABELS[formData.operation_class] || formData.operation_class}
              />
            </ReviewCard>

            <ReviewCard title="Schedule & Team">
              <ReviewRow label="Date" value={formData.date || formData.operation_date} />
              <ReviewRow label="Start Time" value={formData.start_time || formData.estimated_start_time} />
              <ReviewRow
                label="Duration"
                value={`${formData.duration_hours || 0}h ${formData.duration_minutes || 0}m`}
              />
              <ReviewRow label="Theatre" value={formData.theatre_name || formData.theatre} />
              <ReviewRow label="Lead Surgeon" value={formData.lead_surgeon} />
              <ReviewRow label="Anaesthetist" value={formData.lead_anaesthetist} />
              {formData.scrub_nurse && <ReviewRow label="Scrub Nurse" value={formData.scrub_nurse} />}
              {formData.circulating_nurse && <ReviewRow label="Circulating Nurse" value={formData.circulating_nurse} />}
              <ReviewRow
                label="Anaesthesia"
                value={ANAESTHESIA_TYPE_LABELS[formData.anaesthesia_type] || formData.anaesthesia_type}
              />
            </ReviewCard>
          </Grid>

          {/* Right column — Billing */}
          <Grid item xs={12} md={6}>
            {/* Payment type banner */}
            {isInsured ? (
              <div style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 14px', marginBottom: 16,
                backgroundColor: '#E3F2FD', borderRadius: 8, border: '1px solid #90CAF9',
              }}>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  backgroundColor: '#1565C0', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 700, fontSize: 13, flexShrink: 0,
                }}>
                  {(insuranceInfo.provider_name || 'I')[0]}
                </div>
                <div style={{ flex: 1 }}>
                  <Typography variant="body2" style={{ fontWeight: 600, fontSize: '0.82rem' }}>
                    {insuranceInfo.provider_name}
                  </Typography>
                  <Typography variant="caption" style={{ color: '#555' }}>
                    {coPayPct > 0 ? `${coPayPct}% co-pay` : 'Full coverage'}
                    {preauthRef ? ` · Ref: ${preauthRef}` : ''}
                  </Typography>
                </div>
                <Typography variant="caption" style={{
                  padding: '3px 8px', borderRadius: 10, fontWeight: 600, fontSize: '0.65rem',
                  backgroundColor: insuranceScenario === 'full' ? '#E8F5E9' : insuranceScenario === 'partial' ? '#FFF3E0' : '#FFEBEE',
                  color: insuranceScenario === 'full' ? '#2E7D32' : insuranceScenario === 'partial' ? '#E65100' : '#C62828',
                }}>
                  {insuranceScenario === 'full' ? 'Full' : insuranceScenario === 'partial' ? 'Partial' : 'None'}
                </Typography>
              </div>
            ) : (
              <div style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 14px', marginBottom: 16,
                backgroundColor: '#F5F5F5', borderRadius: 8, border: '1px solid #E0E0E0',
              }}>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  backgroundColor: '#757575', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 700, fontSize: 14, flexShrink: 0,
                }}>$</div>
                <Typography variant="body2" style={{ fontWeight: 600, fontSize: '0.82rem' }}>
                  Cash / Self-Pay
                </Typography>
              </div>
            )}

            {/* Billing tables — split by insurance/cash for insured, single table for cash */}
            {isInsured && hasInsItems ? (
              <>
                <ReviewItemTable items={insuranceBillItems} label={`Insurance Bill — ${insuranceInfo.provider_name}`} bgColor="#E3F2FD" />
                {cashBillItems.length > 0 && (
                  <ReviewItemTable items={cashBillItems} label="Patient Cash Bill" bgColor="#FFF8E1" />
                )}
              </>
            ) : (
              <ReviewItemTable
                items={billItems.filter(i => i.service_id)}
                label={isInsured ? 'Patient Cash Bill (no insurance items)' : 'Billing Estimate'}
              />
            )}

            {/* Room estimate */}
            {formData.pathway === PATHWAY.INPATIENT && roomEstimate.total > 0 && (
              <div style={{ padding: '8px 12px', marginBottom: 12, backgroundColor: '#FAFAFA', borderRadius: 6, border: '1px solid #E0E0E0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2" color="textSecondary">Room / Ward ({roomEstimate.estimated_days} days)</Typography>
                  <Typography variant="body2" style={{ fontWeight: 600 }}>{formatCurrency(roomEstimate.total)}</Typography>
                </div>
              </div>
            )}

            {/* Payment summary */}
            {isInsured && hasInsItems ? (
              <div className={classes.reviewCard}>
                <div className={classes.reviewCardHeader}>
                  <span className={classes.reviewCardHeaderTitle}>Payment Summary</span>
                </div>
                <div className={classes.reviewCardBody}>
                  <ReviewRow label={`Insurance bill (${insuranceBillItems.length} items)`} value={formatCurrency(insuranceItemsTotal)} />
                  {coPayPct > 0 && (
                    <>
                      <ReviewRow label={`Insurer pays (${100 - coPayPct}%)`} value={formatCurrency(insurerPays)} />
                      <ReviewRow label={`Co-pay (${coPayPct}%)`} value={formatCurrency(coPayAmount)} />
                    </>
                  )}
                  {cashBillItems.length > 0 && (
                    <ReviewRow label={`Cash items (${cashBillItems.length})`} value={formatCurrency(cashItemsTotal)} />
                  )}
                  {formData.pathway === PATHWAY.INPATIENT && roomEstimate.total > 0 && (
                    <ReviewRow label="Room / Ward" value={formatCurrency(roomEstimate.total)} />
                  )}
                  <div style={{ borderTop: '2px solid #E0E0E0', marginTop: 6, paddingTop: 6, display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" style={{ fontWeight: 700 }}>Patient Pays</Typography>
                    <Typography variant="body2" style={{ fontWeight: 700 }}>{formatCurrency(patientResponsibility)}</Typography>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ padding: '12px 16px', backgroundColor: '#F5F5F5', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" style={{ fontWeight: 700 }}>Estimated Total</Typography>
                <Typography variant="h6" style={{ fontWeight: 700 }}>{formatCurrency(billingGrandTotal)}</Typography>
              </div>
            )}

            {/* Pre-auth info */}
            {isInsured && hasInsItems && (preauthRef || preauthJustification) && (
              <ReviewCard title="Pre-Authorisation">
                {preauthRef && <ReviewRow label="Reference" value={preauthRef} />}
                {preauthJustification && <ReviewRow label="Justification" value={preauthJustification} />}
              </ReviewCard>
            )}
            {isInsured && hasInsItems && !preauthRef && (
              <Box px={1} mb={1} mt={1}>
                <Typography variant="caption" style={{ color: '#E65100', fontSize: '0.72rem' }}>
                  No pre-auth reference provided — one will be auto-generated.
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return renderPatientProcedure();
      case 1:
        return renderDateTheatreTeam();
      case 2:
        return renderBillingEstimate();
      case 3:
        return renderReviewConfirm();
      default:
        return null;
    }
  };

  return (
    <div>
      <PageTitle title="Schedule Surgery" />
      <SubHeader title="Surgery" subTitle="Schedule Surgery" />
      <Paper className={classes.root} elevation={1}>
        <Stepper activeStep={activeStep} className={classes.stepper} alternativeLabel>
          {STEPS.map((label, index) => (
            <Step
              key={label}
              completed={Boolean(completedSteps[index])}
              onClick={() => handleStepClick(index)}
              style={{ cursor: completedSteps[index] || index < activeStep ? 'pointer' : 'default' }}
            >
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <div className={classes.content}>{getStepContent(activeStep)}</div>

        <Divider />

        <div className={classes.navButtons}>
          {activeStep > 0 && (
            <button onClick={handleBack} className="btn sms-gray-btn">
              Back
            </button>
          )}
          {activeStep < STEPS.length - 1 && (
            <button onClick={handleNext} className="btn sms-info-btn">
              Next
            </button>
          )}
          {activeStep === STEPS.length - 1 && (
            <button
              onClick={handleSubmit}
              className="btn sms-info-btn"
              disabled={submitting}
            >
              {submitting ? 'Scheduling...' : 'Confirm & Schedule'}
            </button>
          )}
        </div>
      </Paper>

      {/* Admission Prompt after successful scheduling */}
      {admissionPromptOpen && (
        <CustomDialog open={admissionPromptOpen} handleClose={() => {
          setAdmissionPromptOpen(false);
          history.push('/surgery/list');
        }} title="Surgery Scheduled Successfully" maxWidth="sm">
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p style={{ marginBottom: 20 }}>
              Surgery has been scheduled successfully. Would you like to admit the patient now?
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
              <button className="btn btn-sm sms-info-btn" onClick={() => {
                setAdmissionPromptOpen(false);
                if (scheduledResult && scheduledResult.surgery_id) {
                  history.push(`/surgery/detail/${scheduledResult.surgery_id}?section=admission`);
                } else {
                  history.push('/surgery/list');
                }
              }}>
                Admit Now
              </button>
              <button className="btn btn-sm sms-gray-btn" onClick={() => {
                setAdmissionPromptOpen(false);
                history.push('/surgery/list');
              }}>
                Skip for Now
              </button>
            </div>
          </div>
        </CustomDialog>
      )}
    </div>
  );
};

export default ScheduleSurgeryWizard;
